import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'app/modules/shared/components/base.component';

@Component({
  selector: 'page-practitioner',
  templateUrl: './practitioner.component.html',
  styleUrls: ['./practitioner.component.scss'],
})
export class HomePractitionerComponent extends BaseComponent implements OnInit {
  public chartItens: any[] = [];

  ngOnInit(): void {}

  getChartData() {
    //@TODO buscar dados para o chart do especialista
    this.chartItens = this.setChartDummyData();
  }
}
